<template>
  <div class="flex items-center justify-center mt-4">
    <a
      href="/social-login/twitter"
      class="social-icon-hover"
    >
      <svg
        width="32"
        height="26"
        class="w-full"
        viewBox="0 0 32 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32 3.078C30.81 3.6 29.542 3.946 28.22 4.114C29.58 3.302 30.618 2.026 31.106 0.488C29.838 1.244 28.438 1.778 26.946 2.076C25.742 0.794 24.026 0 22.154 0C18.522 0 15.598 2.948 15.598 6.562C15.598 7.082 15.642 7.582 15.75 8.058C10.296 7.792 5.47 5.178 2.228 1.196C1.662 2.178 1.33 3.302 1.33 4.512C1.33 6.784 2.5 8.798 4.244 9.964C3.19 9.944 2.156 9.638 1.28 9.156C1.28 9.176 1.28 9.202 1.28 9.228C1.28 12.416 3.554 15.064 6.536 15.674C6.002 15.82 5.42 15.89 4.816 15.89C4.396 15.89 3.972 15.866 3.574 15.778C4.424 18.376 6.836 20.286 9.704 20.348C7.472 22.094 4.638 23.146 1.57 23.146C1.032 23.146 0.516 23.122 0 23.056C2.906 24.93 6.35 26 10.064 26C22.136 26 28.736 16 28.736 7.332C28.736 7.042 28.726 6.762 28.712 6.484C30.014 5.56 31.108 4.406 32 3.078Z"
          fill="#03A9F4"
        />
      </svg>
    </a>
    <a
      href="/social-login/google"
      class="mx-12 social-icon-hover"
    >
      <svg
        width="33"
        height="32"
        class="w-full"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2553_13854)">
          <path
            d="M31.5918 13.2186L18.5393 13.218C17.9629 13.218 17.4957 13.6851 17.4957 14.2615V18.4312C17.4957 19.0075 17.9629 19.4747 18.5392 19.4747H25.8896C25.0847 21.5635 23.5825 23.3128 21.6659 24.4243L24.8 29.8499C29.8277 26.9422 32.8 21.8404 32.8 16.1293C32.8 15.3161 32.7401 14.7348 32.6202 14.0802C32.5291 13.5829 32.0973 13.2186 31.5918 13.2186Z"
            fill="#167EE6"
          />
          <path
            d="M16.8 25.739C13.2029 25.739 10.0626 23.7737 8.37606 20.8654L2.95068 23.9925C5.71162 28.7776 10.8837 31.9999 16.8 31.9999C19.7023 31.9999 22.4409 31.2185 24.8 29.8567V29.8492L21.6658 24.4236C20.2322 25.2551 18.5732 25.739 16.8 25.739Z"
            fill="#12B347"
          />
          <path
            d="M24.8 29.8569V29.8495L21.6659 24.4238C20.2322 25.2553 18.5734 25.7393 16.8 25.7393V32.0001C19.7024 32.0001 22.441 31.2187 24.8 29.8569Z"
            fill="#0F993E"
          />
          <path
            d="M7.06092 16.0001C7.06092 14.2271 7.5448 12.5683 8.37611 11.1347L2.95074 8.00757C1.58142 10.3593 0.800049 13.0904 0.800049 16.0001C0.800049 18.9099 1.58142 21.641 2.95074 23.9927L8.37611 20.8656C7.5448 19.432 7.06092 17.7732 7.06092 16.0001Z"
            fill="#FFD500"
          />
          <path
            d="M16.8 6.26088C19.1457 6.26088 21.3003 7.09437 22.9832 8.48081C23.3984 8.82281 24.0019 8.79813 24.3822 8.41781L27.3366 5.46344C27.7681 5.03194 27.7373 4.32562 27.2764 3.92575C24.4567 1.47956 20.7879 0 16.8 0C10.8837 0 5.71162 3.22231 2.95068 8.00744L8.37606 11.1346C10.0626 8.22625 13.2029 6.26088 16.8 6.26088Z"
            fill="#FF4B26"
          />
          <path
            d="M22.9833 8.48081C23.3985 8.82281 24.002 8.79813 24.3822 8.41781L27.3366 5.46344C27.7681 5.03194 27.7373 4.32562 27.2764 3.92575C24.4567 1.4795 20.788 0 16.8 0V6.26088C19.1457 6.26088 21.3004 7.09437 22.9833 8.48081Z"
            fill="#D93F21"
          />
        </g>
        <defs>
          <clipPath id="clip0_2553_13854">
            <rect
              width="32"
              height="32"
              fill="white"
              transform="translate(0.800049)"
            />
          </clipPath>
        </defs>
      </svg>
    </a>
    <a
      href="/social-login/facebook"
      class="social-icon-hover"
    >
      <svg
        width="33"
        height="32"
        class="w-full"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2553_13863)">
          <path
            d="M28.8 0H4.80005C2.59405 0 0.800049 1.794 0.800049 4V28C0.800049 30.206 2.59405 32 4.80005 32H28.8C31.006 32 32.8 30.206 32.8 28V4C32.8 1.794 31.006 0 28.8 0Z"
            fill="#1976D2"
          />
          <path
            d="M27.8 16H22.8V12C22.8 10.896 23.696 11 24.8 11H26.8V6H22.8C19.486 6 16.8 8.686 16.8 12V16H12.8V21H16.8V32H22.8V21H25.8L27.8 16Z"
            fill="#FAFAFA"
          />
        </g>
        <defs>
          <clipPath id="clip0_2553_13863">
            <rect
              width="32"
              height="32"
              fill="white"
              transform="translate(0.800049)"
            />
          </clipPath>
        </defs>
      </svg>
    </a>
  </div>
</template>

<script>
export default {
    name: "SocialMedia"
}
</script>

<style scoped>
.social-icon-hover:hover {
    transform: scale(1.2);
    transition: all 1s;
}
</style>